import { Component, OnInit } from "@angular/core";
import { NotificationService } from "../../../notification/shared/notification.service";
import { ChangePasswordRequest } from "../shared/change-password-request";
import { ProfileService } from "../shared/profile.service";
import { PasswordChangeForm } from "./password-change-form";

@Component({
  selector: "app-password-change",
  templateUrl: "./password-change.component.html",
  styleUrls: ["../shared/profile.scss", "./password-change.component.scss"]
})
export class PasswordChangeComponent implements OnInit {
  form: PasswordChangeForm;
  formVisibility: Map<string, boolean>;

  isSize: boolean = false;
  isMaj: boolean = false;
  isMin: boolean = false;
  isNum: boolean = false;
  isSpecial: boolean = false;
  isNotLogin: boolean = true;

  constructor(
    private profileService: ProfileService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.formVisibility = new Map<string, boolean>();
    this.formVisibility.set("currentPassword", false);
    this.formVisibility.set("newPassword", false);
    this.formVisibility.set("confirmPassword", false);
    this.form = new PasswordChangeForm();
  }

  getFormType(formId: string) {
    return this.isVisible(formId) ? "text" : "password";
  }

  isVisible(formId: string) {
    return this.formVisibility.has(formId) && this.formVisibility.get(formId);
  }

  toggleVisibility(formId: string) {
    this.formVisibility.set(formId, !this.isVisible(formId));
  }

  private changeSuccess(result) {
    this.notificationService.notif(result, "notif");
  }

  private prepareRequest(): ChangePasswordRequest {
    return {
      current_password: this.form.get("currentPassword").value as string,
      new_password: this.form.get("newPassword").value as string,
      confirm_password: this.form.get("confirmPassword").value as string,
    };
  }

  public submit() {
    if (this.form.valid) {
      if (this.isValidPassword()) {
        this.profileService
          .changePassword(this.prepareRequest())
          .subscribe(
            confirm => this.changeSuccess(confirm)
          );
      } else {
        this.notificationService.notif("Le nouveau mot de passe ne respecte pas les critères", "error");
      }
    }
  }

  public isValidPassword(event: any = null) {
    if (event) {
      let password = event.target.value;
      this.isSize = (password.length >= 8);
      this.isMaj = /[A-Z]/.test(password);
      this.isMin = /[a-z]/.test(password);
      this.isNum = /[0-9]/.test(password);
      this.isSpecial = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(password);
      this.profileService.getProfileOfCurrentUser().subscribe(user => {
        this.isNotLogin = (password !== user['username']);
      })
    }
    return this.isSize && this.isMaj && this.isMin && this.isNum && this.isSpecial && this.isNotLogin;
  }
}
